import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class CountryStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
